import HaveSamp from "@/views/samp/havesamp/HaveSamp"
export const havesamp = {
    path: '/havesamp',
    name: 'HaveSamp',
    component: HaveSamp
  }


// WEBPACK FOOTER //
// ./src/router/index/samp/havesamp/index.js